<template>
  <div class="password-input">
    <input
      :id="id"
      :type="isVisible ? 'text' : 'password'"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      :required="required"
      :placeholder="placeholder"
      class="password-input__field"
    />
    <button
      type="button"
      class="password-input__toggle"
      @click="toggleVisibility"
      :aria-label="isVisible ? 'Скрыть пароль' : 'Показать пароль'"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
        <circle cx="12" cy="12" r="3"></circle>
      </svg>
    </button>
  </div>
</template>

<script setup>
import { ref } from 'vue'

defineProps({
  id: {
    type: String,
    required: true,
  },
  modelValue: {
    type: String,
    default: '',
  },
  required: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: '',
  },
})

defineEmits(['update:modelValue'])

const isVisible = ref(false)

function toggleVisibility() {
  isVisible.value = !isVisible.value
}
</script>

<style lang="scss" scoped>
.password-input {
  position: relative;
  width: 100%;
  color: inherit;
  &:hover,
  &:focus-within {
    .password-input__toggle {
      opacity: 0.4;
    }
  }

  &__field {
    font-weight: 400;
    color: #000000;
    padding: 0 12px;
    min-height: 44px;
    border: 1px solid #000000;
    border-radius: 4px;
    width: 100%;
    font-family: inherit;
    padding-right: 40px;

    &.small {
      min-height: 36px;
    }

    &::placeholder {
      color: #d9d9d9;
    }
  }

  &__toggle {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    color: inherit;
    &:hover {
      opacity: 1 !important;
    }
  }
}
</style>
